module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_c('header', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePreview($event)
      }
    }
  }, [_vm._v("← Quit [ESC]")])]), _vm._v(" "), (_vm.type === 'thread') ? _c('thread', {
    attrs: {
      "content": _vm.content
    }
  }) : _c('div', [(_vm.content.data.children[0].data.post_hint === 'image') ? _c('div', [_c('img', {
    ref: "imageSource",
    attrs: {
      "src": _vm.content.data.children[0].data.url
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-577a61fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = 293
// module chunks = 2